import request from '@/scripts/request';
import { exportApis } from '@/scripts/utils/devUtils';
import type { MyAxiosResponse } from '@/scripts/request/types';
import {
  UploadFileCategory,
  type uploadFileParams,
  type uploadFileResponse,
} from './type';

export const commonApis = {
  getSystemDate() {
    return request('/api/v1/system/time').then((res) => res.data.time);
  },
  getFileSDKToken() {
    return request('/api/v1/file/token/generate', { method: 'POST' }).then(
      (res) => res.data.token
    );
  },
  postUpload(params: uploadFileParams) {
    return request<MyAxiosResponse<uploadFileResponse>>('/api/v1/file/upload/presign', {
      method: 'POST',
      data: params,
    });
  },
  putUpload(url: string, data: File, type: string) {
    return request(`${url}`, {
      method: 'put',
      headers: {
        Authorization: undefined,
        'Content-Type': type || 'multipart/form-data',
      },
      data,
    });
  },
  uploadFile(params: { file: File } & uploadFileParams) {
    const { file, category, ...rest } = params;
    const types = {
      [UploadFileCategory.AVATAR]: file.type,
    };

    return this.postUpload({
      type: file?.name.split('.').pop(),
      category,
      ...rest,
    }).then(({ data }) =>
      this.putUpload(data.url, file, types[category!]).then(() => data)
    );
  },
};

exportApis({ commonApis });
